import type { FeatureStates } from '../featureStates';
import { pageIds } from '../pages/pageIds';

export function isPageActive(pageId: number, features: FeatureStates, singleUserVersion: boolean): boolean {
  switch (pageId) {
    case pageIds.status:
      return true;
    case pageIds.events:
      return features.pageEvents;
    case pageIds.staffing:
      return features.staffing && !singleUserVersion;
    case pageIds.meetings:
      return features.meetings;
    case pageIds.assets:
      return features.assets;
    case pageIds.substances:
      return features.substances;
    case pageIds.dataSystems:
      return features.data;
    case pageIds.issues:
      return features.issues;
    case pageIds.riskAssessments:
      return features.risk;
    case pageIds.management:
      return features.core || features.hse;
    case pageIds.hse:
      return features.core || features.hse;
    case pageIds.business:
      return features.core || features.hse;
    case pageIds.assetManagement:
      return features.core;
    case pageIds.informationSecurity:
      return features.core;
    case pageIds.emergency:
      return features.emergency;
    case pageIds.quality:
      return features.core || features.quality;
    case pageIds.company:
      return true;
    case pageIds.employees:
      return features.pageEmployees;
    case pageIds.partners:
      return features.pagePartners;
    case pageIds.people:
      return features.pagePeople;
    case pageIds.tutorials:
      return features.core;
    case pageIds.collections:
      return features.collections;
    case pageIds.references:
      return features.core || features.hse;
    case pageIds.trash:
      return true;
  }
  return false;
}
